export const toWebviewRouteName = (n: string) => `${n}-webview`

/**
 * If the route name is a CMS webview route name, it returns the equivalent regular route name
 * Example:
 * "event-page-webview" -> "event-page"
 * "core-webview" -> "core"
 * "event-page" -> "event-page"
 */
export const dewebviewifyRouteName = (n: string): string => {
  if (n?.endsWith('-webview')) return n.split('-webview')?.[0]

  return n
}
